import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const Footer = () => {
    return (
        <div className="copyright-text"><p>&copy; {new Date().getFullYear()} RevRex  Powered by RevRex</p></div>
    );
}

export default Footer;